import { AUTHTOKEN } from "@/constants";
import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client/core";
import { setContext } from '@apollo/client/link/context';

// HTTP connection to the API
const httpLink = createHttpLink({
  uri: "https://graph-portal.nasna.tv/"
});

// Middleware to add the custom header
const authLink = setContext((_, { headers }) => {
  // Get the access token from local storage or any other storage
  const token = localStorage.getItem(AUTHTOKEN);
  return {
    headers: {
      ...headers,
      'access-token': token ? token : ""
    }
  };
});

// Cache implementation
const cache = new InMemoryCache();

// Create the Apollo Client
const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
});

export default apolloClient;